import { Icon } from "@iconify/react";
import { Drawer, Flex, Grid, Image, Layout, Menu } from "antd";
import { Link, useLocation } from "react-router";
import logo from "../assets/logo_pam.webp";
import pallete from "../utils/pallete";
import { useAuth } from "../hooks/useAuth";
import { sidebarStore } from "../store/sidebarStore";

// eslint-disable-next-line react/prop-types
function SubmenuIcon({ collapse }) {
  return (
    <Icon
      icon="lucide:dot"
      style={
        collapse
          ? { marginBottom: -9, marginLeft: -10, marginRight: 0 }
          : { marginBottom: -1, marginLeft: -30, marginRight: 0 }
      }
      width="28"
      height="28"
    />
  );
}

const filterMenuItems = (menuItems, permissions) => {
  if (permissions.includes("*")) {
    return menuItems;
  }
  return menuItems.filter((item) => {
    const hasPermission = permissions.includes(
      typeof item.label === "string" ? item.label : item.label.props.children
    );

    // if (item.children) {
    //   item.children = filterMenuItems(item.children, permissions);
    //   return item.children.length > 0;
    // }

    return hasPermission;
  });
};

export default function Sidebar() {
  const location = useLocation();

  const breakpoint = Grid.useBreakpoint();

  const { user } = useAuth();

  const { collapse, drawerCollapse, toggleDrawer } = sidebarStore(
    (state) => state
  );

  const getSelectedKey = () => {
    if (location.pathname == "/") {
      return ["dashboard"];
    }
    return location.pathname.replace("/", "");
  };

  const getOpenKey = () => {
    if (location.pathname == "/") {
      return [];
    }

    if (location.pathname.includes("bill-simulation")) {
      return ["bill-simulation"];
    }

    if (location.pathname.includes("lab-service")) {
      return ["lab-service"];
    }

    // if(location.pathname.includes('registration')){
    //   return ['registration']
    // }

    if (
      location.pathname.includes("registration") &&
      !location.pathname.includes("registration-pending")
    ) {
      return ["registration"];
    }

    if (location.pathname.includes("customer-care")) {
      return ["customer-care"];
    }
    if (location.pathname.includes("document-analysis")) {
      return ["document-analysis"];
    }
    if (location.pathname.includes("master-data")) {
      return ["master-data"];
    }
    if (location.pathname.includes("data-selection")) {
      return ["data-selection"];
    }
    if (location.pathname.includes("customer-care")) {
      return ["customer-care"];
    }
    if (location.pathname.includes("water-purifier")) {
      return ["water-purifier"];
    }
    return [];
  };

  const items = [
    {
      key: "dashboard",
      label: <Link to={"/"}>Dashboard</Link>,
      icon: (
        <Icon
          icon="duo-icons:dashboard"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="22"
          height="22"
        />
      ),
    },
    {
      key: "banner",
      permission: "Banner",
      label: <Link to={"/banner"}>Banner</Link>,
      icon: (
        <Icon
          icon="solar:gallery-minimalistic-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "registration",
      permission: "Monitoring SR",
      label: "Monitoring SR",
      icon: (
        <Icon
          icon="solar:waterdrop-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "registration/process",
          label: <Link to={"/registration/process"}>Sedang Diproses</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "registration/canceled",
          label: <Link to={"/registration/canceled"}>Cancel Pendaftaran</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "data-rcc",
      permission: "Data RCC",
      label: "RCC",
      icon: (
        <Icon
          icon="solar:waterdrop-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "data-rcc",
          label: <Link to={"/data-rcc"}>Data RCC</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "registration/canceled",
          label: <Link to={"/registration/canceled"}>Cancel Pendaftaran</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        // {
        //   key: "rcc/payment-proof",
        //   label: <Link to={"/rcc/payment-proof"}>Bukti Pembayaran</Link>,
        //   icon: <SubmenuIcon collapse={collapse} />,
        // },
      ],
    },
    {
      key: "registration-pending",
      permission: "SR Masuk",
      label: <Link to={"/registration-pending"}>SR Masuk</Link>,
      icon: (
        <Icon
          icon="solar:waterdrop-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "survey",
      permission: "Survey Pelanggan",
      label: <Link to={"/survey"}>Survey Pelanggan</Link>,
      icon: (
        <Icon
          icon="solar:checklist-minimalistic-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "document-analysis",
      permission: "Analisa Berkas",
      label: "Analisa Berkas",
      icon: (
        <Icon
          icon="solar:folder-with-files-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        !["Surveyor", "Officer"].includes(user?.user?.subdivision) && {
          key: "document-analysis/pending",
          label: (
            <Link to={"/document-analysis/pending"}>Analisa Marketing</Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        user?.user?.subdivision == "Officer" && {
          key: "document-analysis/process",
          label: <Link to={"/document-analysis/process"}>Analisa Officer</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "document-analysis/canceled",
          label: <Link to={"/document-analysis/canceled"}>Cancel Survey</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "registration-finish",
      permission: "Data Terpasang",
      label: <Link to={"/registration-finish"}>Data Terpasang</Link>,
      icon: (
        <Icon
          icon="solar:folder-path-connect-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "registration-all",
      permission: "Report Sambungan Baru",
      label: <Link to={"/registration-all"}>Report Sambungan Baru</Link>,
      icon: (
        <Icon
          icon="solar:folder-with-files-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "lab-service",
      permission: "Layanan Lab",
      label: "Layanan Lab",
      icon: (
        <Icon
          icon="solar:clipboard-check-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "lab-service/rate-per-commodity",
          label: (
            <Link to={"/lab-service/rate-per-commodity"}>
              Tarif Per Komoditi
            </Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "lab-service/rate-per-meter",
          label: (
            <Link to={"/lab-service/rate-per-parameter"}>
              Tarif Per Parameter
            </Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "lab-service/another-rate",
          label: <Link to={"/lab-service/other-rates"}>Tarif Lainnya</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "lab-service/testimony",
          label: <Link to={"/lab-service/testimony"}>Testimoni</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "disturbance-information",
      permission: "Informasi Gangguan",
      label: <Link to={"/disturbance-information"}>Informasi Gangguan</Link>,
      icon: (
        <Icon
          icon="solar:info-square-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "customer-care",
      label: "Customer Care",
      permission: "Customer Care",
      icon: (
        <Icon
          icon="duo-icons:clipboard"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "customer-care/office",
          label: <Link to={"/customer-care/office"}>Kantor Pelayanan</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "customer-care/faq-category",
          label: <Link to={"customer-care/faq-category"}>Kategori FAQ</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "customer-care/faq",
          label: <Link to={"/customer-care/faq"}>FAQ</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "complaint",
      permission: "Pengaduan",
      label: "Pengaduan",
      icon: (
        <Icon
          icon="solar:documents-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "complaint/customer",
          label: <Link to={"complaint/customer"}>Pelanggan</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "complaint/non-customer",
          label: <Link to={"complaint/non-customer"}>NonPelanggan</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "complaint/category",
          label: <Link to={"complaint/category"}>Kategori Aduan</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "water-tank",
      permission: "Air Tangki",
      label: <Link to={"water-tank"}>Air Tangki</Link>,
      icon: (
        <Icon
          icon="game-icons:water-tank"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "user-management",
      permission: "User Management",
      label: 'User Management',
      icon: (
        <Icon
          icon="solar:users-group-two-rounded-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "user-management/user-account",
          label: <Link to={"/user-management/user-account"}>Akun User</Link>,
          icon: (
            <Icon
              icon="solar:users-group-two-rounded-bold-duotone"
              style={{ marginBottom: -1, marginLeft: -5 }}
              width="20"
              height="20"
            />
          )
        },
        {
          key: "user-management/customer-verification",
          label: <Link to={"/user-management/customer-verification"}>Pelanggan Terverifikasi</Link>,
          icon: (
            <Icon
              icon="solar:users-group-two-rounded-bold-duotone"
              style={{ marginBottom: -1, marginLeft: -5 }}
              width="20"
              height="20"
            />
          )
        },
        {
          key: "user-management/redeem",
          label: <Link to={"/user-management/redeem"}>Redeem Reward</Link>,
          icon: (
            <Icon
              icon="solar:gift-bold-duotone"
              style={{ marginBottom: -1, marginLeft: -5 }}
              width="20"
              height="20"
            />
          )
        },
      ]
    },
    {
      key: "stand-meter",
      permission: "Stand Meter",
      label: <Link to={"stand-meter"}>Stand Meter</Link>,
      icon: (
        <Icon
          icon="ion:ios-speedometer"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
    {
      key: "master-data",
      label: "Master Data",
      permission: "Master Data",
      icon: (
        <Icon
          icon="solar:box-minimalistic-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "master-data/reward",
          label: <Link to={"master-data/reward"}>Reward</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "master-data/user",
          label: <Link to={"master-data/user"}>Pengguna</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "master-data/business-area",
          label: <Link to={"master-data/business-area"}>Area Bisnis</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "data-selection",
      label: "Data Selection",
      permission: "Master Data",
      icon: (
        <Icon
          icon="solar:box-minimalistic-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "data-selection-type",
          label: (
            <Link to={"data-selection/data-selection-type"}>Kategorisasi</Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "data-selection-item",
          label: <Link to={"data-selection/data-selection-item"}>Options</Link>,
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "bill-simulation",
      permission: "Simulasi Tagihan Air",
      label: "Simulasi Tagihan Air",
      icon: (
        <Icon
          icon="solar:folder-path-connect-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
      children: [
        {
          key: "bill-simulation/customer-category",
          label: (
            <Link to={"bill-simulation/customer-category"}>
              Kategori Pelanggan
            </Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "bill-simulation/maintenance-cost",
          label: (
            <Link to={"bill-simulation/maintenance-cost"}>
              Biaya Pemeliharaan
            </Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "bill-simulation/fixed-cost",
          label: (
            <Link to={"bill-simulation/fixed-cost"}>Biaya Beban Tetap</Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
        {
          key: "bill-simulation/faq-category",
          label: (
            <Link to={"bill-simulation/cubication-cost"}>Jenis Pelanggan</Link>
          ),
          icon: <SubmenuIcon collapse={collapse} />,
        },
      ],
    },
    {
      key: "history-log",
      permission: "Riwayat Aktivitas",
      label: <Link to={"history-log"}>Riwayat Aktivitas</Link>,
      icon: (
        <Icon
          icon="solar:folder-path-connect-bold-duotone"
          style={{ marginBottom: -1, marginLeft: -5 }}
          width="20"
          height="20"
        />
      ),
    },
  ];

  return (
    <>
      {breakpoint.md && (
        <Layout.Sider
          style={{
            paddingTop: 20,
            backgroundColor: "#fff",
            paddingLeft: 4,
            paddingRight: 4,
            borderRight: "1px solid " + pallete.grey[200],
            height: "100%",
          }}
          width={240}
          collapsed={collapse}
        >
          <Flex vertical style={{ height: "100%" }}>
            <Flex justify="center">
              <Image
                src={logo}
                style={{ marginBottom: 20 }}
                width={!collapse ? 65 : 50}
                preview={false}
              />
            </Flex>
            <Menu
              items={filterMenuItems(items, user?.user?.permissions)}
              style={{
                borderRight: "none",
                fontWeight: 400,
                overflowY: "auto",
                flex: 1,
              }}
              defaultSelectedKeys={getSelectedKey()}
              defaultOpenKeys={getOpenKey()}
              mode="inline"
            />
          </Flex>
        </Layout.Sider>
      )}
      <Drawer
        open={drawerCollapse}
        placement="left"
        closable={false}
        width={280}
        styles={{
          body: {
            padding: "14px 6px",
          },
        }}
        onClose={toggleDrawer}
      >
        <Flex vertical style={{ height: "100%" }}>
          <Flex justify="center">
            <Image
              src={logo}
              style={{ marginBottom: 20 }}
              width={!collapse ? 60 : 45}
              preview={false}
            />
          </Flex>
          <Menu
            items={filterMenuItems(items, user?.user?.permissions)}
            style={{
              borderRight: "none",
              fontWeight: 400,
              overflowY: "auto",
              flex: 1,
            }}
            defaultSelectedKeys={getSelectedKey()}
            defaultOpenKeys={getOpenKey()}
            mode="inline"
            onClick={toggleDrawer}
          />
        </Flex>
      </Drawer>
    </>
  );
}
